/**
 * Created by RaoMeng on 2018/11/15
 * Desc: 通讯录
 */

export default function PhonesBean() {
    this.icon = ''
    this.claName = ''
    this.claId = ''
    this.name = ''
    this.phone = ''
    this.subjectName = ''
    this.children = []
}